<template>
  <div class="qb-sync-badge">
    <QbBallImg class="logo" />
  </div>
</template>

<script lang="ts" setup>
import QbBallImg from "./qb-logo-ball.svg?component";
</script>

<style lang="scss" scoped>
.logo {
  height: 20px;
}
</style>
